<template>
	<div class="menu-item-container">
		<el-menu-item
			:index="
			'/product/profile/'+item.id"
		>
	
			<i class="right_icon"></i>
			<span slot="title">{{ item.name }}</span>
		</el-menu-item>
	</div>
</template>

<script>
export default {
	components: {},
	props: ['item','show'],
	data() {
		return {}
	},
	watch: {},
	computed: {},
	methods: {},
	created() {},
	mounted() {
		
	},
}
</script>
<style lang="scss" scoped>
.menu-item-container {
}
.right_icon {
	display: inline-block;
	width: 18px;
	height: 18px;
	background: url('../assets/right.png') no-repeat;
}
</style>

